import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import styled from 'styled-components'
import { device } from '../components/Breakpoints'
import ModalComponent from '../components/Modal'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import FotosSlider from '../components/FotosSlider'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import fachadaTour from '../img/fachada-tour.jpg'
import imgTour from '../img/img-tour.jpg'
import iconCama from '../icons/icon-cama.svg'
import iconArmarios from '../icons/icon-armarios.svg'
import iconSofa from '../icons/icon-sofa.svg'
import iconTv from '../icons/icon-tv.svg'
import iconFrigobar from '../icons/icon-frigobar.svg'
import iconMesa from '../icons/icon-mesa.svg'
import iconCofre from '../icons/icon-cofre.svg'
import iconTour from '../icons/icon-tour-virtual.svg'
import { colors } from '../components/Colors'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  @media ${device.mobileL} {
    .inner {
      overflow: hidden;
    }
  }

  section {
    :nth-of-type(odd) {
      background: ${colors.lilasGradiente};
      color: #ffffff;
    }
    :nth-of-type(even) {
      background: #ffffff;
      color: ${colors.verde};
      img {
        height: 100%;
      }
    }
    :nth-of-type(5) {
      background: ${colors.verdeGradiente};
      color: #ffffff;
    }
    :nth-of-type(2) {
      background: url(${fachadaTour});
      background-position: bottom;
      background-size: cover;
      padding: 0;
      @media ${device.mobileL} {
        padding: 0 0 2em;
      }
    }
    .bg {
      padding: 2em;
    }
    .fotos {
      h3 {
        text-align: center;
      }
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.laptop} {
    padding: 2em 4em;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
  .tour {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${device.mobileL} {
      flex-wrap: wrap;
      img {
        width: 100%;
      }
    }
    .tour-img-bg {
      background-image: url(${imgTour});
      background-size: cover;
      height: 250px;
      margin: -40px 0 -40px -152px;
      width: 100%;
      text-indent: -9999px;
      @media ${device.mobileL} {
        display: none;
      }
    }
    .modal-box {
      max-width: 340px;
      text-align: center;
      padding: 5em 3em;
      background: rgba(83, 158, 159, 0.8);
      color: #ffffff;
      @media ${device.mobileL} {
        padding: 2em 2em 1em;
        margin: 0;
        text-align: center;
      }
      img {
        width: 50px;
        height: auto;
      }
      p {
        margin: 0 0 1em;
        @media ${device.mobileL} {
          text-align: center;
        }
      }
    }
  }
  .fotos {
    color: ${colors.cinza};
  }
  .comodidades {
    p {
      text-align: center;
    }
    .list {
      border: 6px solid #ffffff;
      padding: 1.5em;
      display: flex;
      justify-content: space-between;
      margin: 0 -60px;
      @media ${device.laptop} {
        flex-wrap: wrap;
        div {
          margin-top: 20px;
        }
        ::after {
          content: '';
          justify-content: flex-start;
          width: 23%;
        }
      }
      @media ${device.mobileL} {
        flex-wrap: wrap;
        margin: 0;
      }
      img {
        width: 45px;
        min-height: 61px;
        display: block;
        margin: 0 auto 0.5em auto;
      }
      div {
        width: 150px;
        background: #ffffff;
        color: #4a4a4a;
        text-align: center;
        font-size: 0.7em;
        padding: 1em 1em 2em;
        box-sizing: border-box;
        box-shadow: 1px 1px 10px #516d6e;
        @media ${device.mobileL} {
          width: 100%;
          margin: 1em 2em 0;
          img {
            width: 30%;
          }
        }
      }
    }
  }
  .suites {
    display: flex;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    .image {
      width: 408px;
      @media ${device.mobileL} {
        width: 100%;
      }
    }
    .col1 {
      border-right: 1px solid #ffffff;
      padding: 0 2em 0 0;
    }
    .col2 {
      padding: 0 0 0 2em;
      div {
        margin: auto;
      }
      svg {
        color: #539e9f;
      }
    }
    .col1,
    .col2 {
      min-width: 35%;
      display: flex;
      flex-wrap: wrap;
      align-items: end;
      justify-content: space-between;
      width: 50%;
      @media ${device.mobileL} {
        border-right: none;
        border-bottom: 1px solid #ffffff;
        padding: 0 0 2em 0;
      }

      img,
      svg {
        width: 40px;
        display: block;
        margin: 2em auto;
      }
      p {
        margin: 0;
        padding: 0;
        font-size: 0.8em;
        margin-bottom: 1.5em;
        width: 100%;
        height: 30px;
        text-align: center;
      }
      div {
        background: #ffffff;
        color: #4a4a4a;
        font-size: 0.6em;
        text-align: center;
        padding: 1em 1em 3em;
        width: 49%;
        min-height: 162px;
        box-sizing: border-box;
        box-shadow: 1px 1px 10px #516d6e;
        @media ${device.mobileL} {
          width: 100%;
          margin: 2em 5em 0;
        }
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    overflow: visible;
    @media ${device.laptop} {
      display: block;
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    .imgSeguranca {
      margin: 30px -136px 0 20px;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
  }
  :nth-of-type(5) {
    .inner {
      div {
        width: 51%;
        @media ${device.mobileL} {
          width: 100%;
          padding-bottom: 30px;
        }
        @media ${device.laptop} {
          width: 100%;
        }
      }
      img,
      .offsetImgEnd {
        width: 42%;
        @media ${device.laptop} {
          width: 100%;
          margin-top: 20px;
        }
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .offsetImgEnd {
        margin-top: -80px;
        @media ${device.mobileL} {
          margin-top: 0px;
        }
      }
    }
    a {
      color: #ffffff;
    }
  }
  :nth-of-type(6) {
    a {
      text-decoration: none;
      :hover {
        text-decoration: underline;
      }
      strong {
        color: ${colors.lilas};
      }
    }
  }
`
export const AcomodacoesTemplate = ({
  title,
  content,
  slug,
  image,
  imageGatsby,
  imageMobile,
  color,
  area = 'Para gestantes',
  galeria,
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          imageGatsby={imageGatsby}
          imageMobile={imageMobile}
          color={color}
          txtColor="lilas"
          height="211px"
          bottom="-31px"
          right="-34px"
          imgWidth="54%"
          overflow="visible"
          imgInner
          mobileTop="-1%"
          mobileRight="0%"
        />
        <GroupContent>
          <div className="bg">
            <div className="tour">
              <div className="modal-box">
                <img src={iconTour} alt="Tour virtual" />
                <p>Acesse o Tour virtual e conheça nossa estrutura</p>
                <ModalComponent url="https://walkinto.in/tour/-1nxtGNL3f-yxneFfE8hz/Hospital_e_Maternidade_Santa_Joana" />
              </div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="comodidades center">
            <p>
              Aqui, o conforto e a comodidade estão em cada detalhe, da
              disposição dos móveis à iluminação. Temos quartos amplos e
              modernos, equipados com:
            </p>
            <div className="list">
              <div>
                <img src={iconCama} alt="Cama" />
                Cama reclinável contendo grade de segurança
              </div>
              <div>
                <img src={iconArmarios} alt="Armários" />
                Armários
              </div>
              <div>
                <img src={iconSofa} alt="Sofá" />
                Sofá para acomodar acompanhantes e visitantes
              </div>
              <div>
                <img src={iconTv} alt="TV a cabo" />
                TV a cabo com controle remoto
              </div>
              <div>
                <img src={iconFrigobar} alt="Frigobar" />
                Frigobar
              </div>
              <div>
                <img src={iconMesa} alt="Mesa" />
                Mesa para refeições
              </div>
              <div>
                <img src={iconCofre} alt="Cofre" />
                Cofre para guardar pertences
              </div>
            </div>
          </div>
        </GroupContent>

        <GroupContent>
          <div className="inner center fotos">
            <div>
              <p
                dangerouslySetInnerHTML={{ __html: sessoes[0].texto }}
                className="fotos"
              />

              <FotosSlider fotos={galeria} />
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>Segurança e tranquilidade</h2>
          </div>
          <div className="inner center">
            <div>{parse(sessoes[1].texto)}</div>
            {sessoes[1].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[1].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Segurança e tranquilidade"
                className="offsetImgEnd"
              />
            ) : (
              <img
                src={sessoes[1].imagemDaSessao.sourceUrl}
                alt="Segurança e tranquilidade"
                className="offsetImgEnd"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <p>
              Para mais informações sobre nossas acomodações,{' '}
              <Link to="/agendamento-de-visitas">
                <strong>agende sua visita.</strong>
              </Link>
            </p>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

AcomodacoesTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const Acomodacoes = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const imageGatsby = page.opEsDaPGina.imagem.localFile
    ? page.opEsDaPGina.imagem.localFile
    : ''
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const imageMobile = page.imagensMobile.imagemMobile
    ? page.imagensMobile.imagemMobile.sourceUrl
    : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { galeria } = page.galeria
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <AcomodacoesTemplate
        title={page.title}
        content={page.content}
        image={image}
        imageGatsby={imageGatsby}
        imageMobile={imageMobile}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        galeria={galeria}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

Acomodacoes.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Acomodacoes

export const AcomodacoesQuery = graphql`
  query AcomodacoesById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      galeria {
        galeria {
          id
          altText
          title
          sourceUrl
        }
      }
      imagensMobile {
        imagemMobile {
          sourceUrl
          localFile {
            childImageSharp {
              fluid(maxWidth: 1114, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
          localFile {
            childImageSharp {
              fluid(maxWidth: 1114, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
